import FFFErrorBoundary from './FFFErrorBoundary';

export default FFFErrorBoundary;
